import { render, staticRenderFns } from "./nextCustomerorder.vue?vue&type=template&id=2378de10&scoped=true"
import script from "./nextCustomerorder.vue?vue&type=script&lang=js"
export * from "./nextCustomerorder.vue?vue&type=script&lang=js"
import style0 from "./nextCustomerorder.vue?vue&type=style&index=0&id=2378de10&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2378de10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2378de10')) {
      api.createRecord('2378de10', component.options)
    } else {
      api.reload('2378de10', component.options)
    }
    module.hot.accept("./nextCustomerorder.vue?vue&type=template&id=2378de10&scoped=true", function () {
      api.rerender('2378de10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/customerOrder/nextCustomerorder.vue"
export default component.exports